export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

export const CONNECT_LOGIN_LOGO_PATH = '/media/logos/connect_log_login.svg'
export const CONNECT_DASHBOARD_LOGO_PATH = '/media/logos/connect_logo_dashboard.svg'

export function getConnectLoginLogoUrl(): string {
    return toAbsoluteUrl(CONNECT_LOGIN_LOGO_PATH)
}

export function getConnectDashboardLogoUrl(): string {
    return toAbsoluteUrl(CONNECT_DASHBOARD_LOGO_PATH)
}

const ADASTRA_LOGO_PATHS = {
    dev: '/media/logos/default-dark-dev.png',
    qa: '/media/logos/default-dark-qa.png',
    prod: '/media/logos/Ad _Astra_Logo_Red_prod.png',
} as const

export function getAdastraLogoPath(): string {
    const server = process.env.REACT_APP_SERVER

    if (server === 'DEV' || server === 'Local') {
        return ADASTRA_LOGO_PATHS.dev
    }
    if (server === 'QA') {
        return ADASTRA_LOGO_PATHS.qa
    }
    return ADASTRA_LOGO_PATHS.prod
}

export function getAdastraLogoUrl(): string {
    return toAbsoluteUrl(getAdastraLogoPath())
}
